import { EQuizMode } from '@constants';

export const checkCsvData = (formData: { [key: string]: string }[], mode: EQuizMode) => {
  if (formData.length === 0) return false;
  if (mode === EQuizMode.QUIZ) return checkMultipleChoiceCsvData(formData);
  if (mode === EQuizMode.PRACTICE) return checkMultipleChoiceCsvData(formData);
  if (mode === EQuizMode.TRUE_FALSE) return checkTrueFalseCsvData(formData);
  if (mode === EQuizMode.PRACTICAL_CASE) return checkPracticalCaseCsvData(formData);
  return false;
};

const checkMultipleChoiceCsvData = (formData: { [key: string]: string }[]) => {
  return formData.every(row => {
    const hasAnswer1 = 'respuesta_1' in row && row['respuesta_1'] !== null;
    const hasAnswer2 = 'respuesta_2' in row && row['respuesta_2'] !== null;
    const hasAnswer3 = 'respuesta_3' in row ? row['respuesta_3'] !== null : true;
    const hasAnswer4 = 'respuesta_4' in row ? row['respuesta_4'] !== null : true;
    const hasAnswer5 = 'respuesta_5' in row ? row['respuesta_5'] !== null : true;
    const hasTitle = 'pregunta' in row && row['pregunta'] !== null;

    const correctAnswerColumn = `respuesta_${row['respuesta_correcta']}`;
    const hasCorrectAnswer = correctAnswerColumn in row ? row[correctAnswerColumn] !== null : false;

    return (
      hasAnswer1 &&
      hasAnswer2 &&
      hasAnswer3 &&
      hasAnswer4 &&
      hasAnswer5 &&
      hasCorrectAnswer &&
      hasTitle
    );
  });
};

const checkTrueFalseCsvData = (formData: { [key: string]: string }[]) => {
  return formData.every(row => {
    const hasTitle = 'pregunta' in row && row['pregunta'] !== null;
    const hasCorrectAnswer = 'respuesta_correcta' in row && row['respuesta_correcta'] !== null;

    return hasTitle && hasCorrectAnswer;
  });
};

const checkPracticalCaseCsvData = (formData: { [key: string]: string }[]) => {
  return formData.every((row, index) => {
    const hasAnswer1 = 'respuesta_1' in row && row['respuesta_1'] !== null;
    const hasAnswer2 = 'respuesta_2' in row && row['respuesta_2'] !== null;
    const hasAnswer3 = 'respuesta_3' in row ? row['respuesta_3'] !== null : true;
    const hasAnswer4 = 'respuesta_4' in row ? row['respuesta_4'] !== null : true;
    const hasTitle = 'pregunta' in row && row['pregunta'] !== null;
    const hasDescription =
      index === 0 && 'caso_practico' in row ? row['caso_practico'] !== null : true;

    const correctAnswerColumn = `respuesta_${row['respuesta_correcta']}`;
    const hasCorrectAnswer = correctAnswerColumn in row ? row[correctAnswerColumn] !== null : false;

    return (
      hasAnswer1 &&
      hasAnswer2 &&
      hasAnswer3 &&
      hasAnswer4 &&
      hasCorrectAnswer &&
      hasTitle &&
      hasDescription
    );
  });
};
